import { render, staticRenderFns } from "./talk-detail-page.vue?vue&type=template&id=d76e5cf4&scoped=true"
import script from "./talk-detail-page.vue?vue&type=script&lang=js"
export * from "./talk-detail-page.vue?vue&type=script&lang=js"
import style0 from "./talk-detail-page.vue?vue&type=style&index=0&id=d76e5cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76e5cf4",
  null
  
)

export default component.exports